import ImageCropper from './ImageCropper.component';

export default ImageCropper;